import { render } from "./SupermercadosTable.vue?vue&type=template&id=e03edee8&scoped=true"
import script from "./SupermercadosTable.vue?vue&type=script&lang=js"
export * from "./SupermercadosTable.vue?vue&type=script&lang=js"

import "./SupermercadosTable.vue?vue&type=style&index=0&id=e03edee8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e03edee8"]])

export default __exports__